import request from "../request";



// Add Promo Code
export const addPromoCode = (data) => {
    return new Promise(async (resolve, reject) => {
      await request
        .post("promo-code/", data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };
  // Edit PromoCode Details By Id
  export const editPromoCodeDetailsById = (id, body) => {
    return new Promise(async (resolve, reject) => {
      await request
        .put(`promo-code/` + id, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };
  // Get PromoCode List
  export const getPromoCodeList = (data) => {
    return new Promise(async (resolve, reject) => {
      await request
        .get(`/promo-code`, { params: data })
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };
  // Delete PromoCode Details By Id
  export const deletePromoCode = (id) => {
    return new Promise(async (resolve, reject) => {
      await request
        .delete(`promo-code/` + id)
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };